import {
    CHANGE_CAPACITY,
    CHANGE_COLOR,
    SET_ATOMIC_ID,
    SET_DEFAULT_STATE,
} from './constants';

/**
 * Fire when color is selected
 * @param value
 */
export function changeColor (value: string) {
    return {
        type: CHANGE_COLOR,
        value,
    };
}

/**
 * Fire when capacity is selected
 * @param value
 */
export function changeCapacity (value: number) {
    return {
        type: CHANGE_CAPACITY,
        value,
    };
}

/**
 * Set atomic ID
 */
export function setAtomicId (atomicId, forceRerender = true) {
    return {
        type: SET_ATOMIC_ID,
        atomicId,
        forceRerender,
    };
}

/**
 * Set default state
 */
export function setDefaultState (additionalPageOptions) {
    return {
        type: SET_DEFAULT_STATE,
        additionalPageOptions,
    };
}
